export default "__VITE_ASSET__w45rx02k__"